import BreakDownByRegionIndicator from './BreakDownByRegionIndicator';

export default BreakDownByRegionIndicator;
